<template>
  <div class="vg_wrapper">
    <el-card>
      <div class="flexV vg_mb_8">
        通知时间:
        <el-date-picker
          v-model="dateRange"
          class="vg_ml_8 vg_mr_8"
          end-placeholder="结束日期"
          range-separator="至"
          size="small"
          start-placeholder="开始日期"
          style="width: 300px"
          type="daterange"
          value-format="timestamp"
        />
        <el-button icon="el-icon-search" size="small" type="primary" @click="getDataList()">查询</el-button>
        <el-button icon="el-icon-refresh-right" size="small" type="info" @click="buttonRefresh()"> 刷新</el-button>
      </div>
      <SearchTable
        ref="multiTable"
        v-loading="loadFlag"
        :columns="c_tableProperties"
        :data="tableData"
        :needFixedHeight="true"
        :needPagination="true"
        :pageSize="10"
        :tableRowKey="'domesticConsultationFormTable'"
        :tableRowKeyFunction="row => `${row.domestic_consultation_form_id}-${row.consultation_form_deta_id}`"
        :totalPage="totalPage"
        @getTableData="getDataList"
      >
        <template v-slot:operation="scope">
          <div style="display: flex">
            <el-button
              :disabled="scope.row.display_status && scope.row.display_status.indexOf('已回传') !== -1"
              size="mini"
              type="primary"
              @click="showDialog(scope.row)"
            >
              上传
            </el-button>
            <el-button
              :disabled="scope.row.display_status && scope.row.display_status.indexOf('已回传') !== -1"
              size="mini"
              type="warning"
              @click="returnTransmission(scope.row)"
            >
              回传
            </el-button>
          </div>
        </template>
      </SearchTable>
      <el-dialog
        :visible.sync="dialogVisible"
        title="相关文档"
        width="55%"
        @close="getDataList"
        @opened="
          $nextTick(() => {
            $refs.docuAbout.initData();
          })
        "
      >
        <docu-about ref="docuAbout" :addFlag="status" :delFlag="status" :form_id="currentRow.domestic_consultation_form_id"></docu-about>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import SearchTable from '@/components/SearchTableV3.vue';
import { tableProperties } from '@/views/PurchaseManagement/DomesticConsultationForm/js/properties';
import { api } from '@/views/PurchaseManagement/DomesticConsultationForm/js/api';
import DocuAbout from '@/views/PurchaseManagement/DomesticConsultationForm/docuAbout';
import { setTime } from '@api/public';

export default {
  name: 'DomesticConsultationFormList',
  components: {
    SearchTable,
    DocuAbout
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.applyRouteQuery();
          this.getDataList();
        });
      }
    }
  },
  data() {
    return {
      tableProperties: cloneDeep(tableProperties),
      tableData: [],
      totalPage: 0,
      btn: {},
      loadFlag: false,
      currentRow: {},
      dateRange: [],
      dialogVisible: false
    };
  },
  computed: {
    c_tableProperties() {
      return this.tableProperties;
    },
    status() {
      return this.currentRow.display_status !== '已上传已回传';
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.applyRouteQuery();
      this.initData();
      setTimeout(() => {
        this.$refs.multiTable?.refreshTableLayout();
      }, 650);
    });
  },
  methods: {
    applyRouteQuery() {
      let searchForm = this.$refs.multiTable?.searchForm;
      if (!searchForm) return;
      searchForm.sample_no = this.$route.query.sample_no || null;
      searchForm.item_name = this.$route.query.item_name || null;
      searchForm.page_no = 1;
    },
    initData() {
      this.getDataList();
    },
    getDataList() {
      this.loadFlag = true;
      let searchForm = cloneDeep(this.$refs.multiTable.searchForm);
      let deptName = this.$cookies.get('userInfo').dept_name;
      if (deptName === '扬州打样间' || deptName === '上海打样间') searchForm.smpl_dept_name = deptName;
      else searchForm.smpl_dept_name = null;
      setTime(searchForm, 'start_time', 'end_time', this.dateRange || [], true);
      api.getDomesticConsultationFormList(searchForm).then(({ data }) => {
        this.tableData = data.list;
        this.totalPage = data.total;
        this.btn = data.btn;
        this.loadFlag = false;
        this.$nextTick(() => {
          this.$refs.multiTable?.refreshTableLayout();
          setTimeout(() => {
            this.$refs.multiTable?.refreshTableLayout();
          }, 650);
        });
      });
    },
    buttonRefresh() {
      this.dateRange = [];
      this.$refs.multiTable.resetFields();
      this.getDataList();
    },
    showDialog(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    returnTransmission(row) {
      api.updateCallbackStatus({ id: row.domestic_consultation_form_id, status: 1 }).then(() => {
        this.$message({
          message: '回传成功',
          type: 'success'
        });
        this.getDataList();
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
